import { Grid, Typography } from '@mui/material';
import { usePqrReconsideration } from './hook';
import { PqrReconsiderationProps } from './props';
import FieldSelect from '../../../../../components/general/fields/fieldSelect';
import { formatParams } from '../../../../../../shared/utils/params';
import FieldText from '../../../../../components/general/fields/fieldText';

export const PqrReconsideration = (props: PqrReconsiderationProps) => {
    const { formik, replicas, replicaParam } = usePqrReconsideration(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Reconsideración
                </Typography>
            </Grid>
            {formik.values.hasReconsideration && (
                <Grid item xs={12} sm={6} md={4}>
                    <FieldSelect
                        data={formatParams(replicas)}
                        label="¿Es una reconsideración?"
                        name="replica"
                        size="small"
                        required
                        onBlur={formik.handleBlur}
                        touched={formik.touched.replica}
                        errors={formik.errors.replica}
                        value={formik.values.replica as string}
                        onChange={formik.handleChange}
                    />
                </Grid>
            )}
            {formik.values.replica === replicaParam?.id && (
                <>
                    <Grid item xs={12} md={4}>
                        <FieldText
                            label="ID PQR del cual es replica"
                            name="pqrReplica"
                            size="small"
                            required
                            onBlur={formik.handleBlur}
                            touched={formik.touched.pqrReplica}
                            errors={formik.errors.pqrReplica}
                            value={formik.values.pqrReplica}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FieldText
                            label="Observaciones"
                            name="observations"
                            size="small"
                            required
                            rows={3}
                            onBlur={formik.handleBlur}
                            touched={formik.touched.observations}
                            errors={formik.errors.observations}
                            value={formik.values.observations}
                            onChange={formik.handleChange}
                        />
                    </Grid>
                </>
            )}
        </Grid>
    );
};
